import createIframe from './iframe';
import createGauge from './gauge';
import createRobotVelocities from './robot-velocities';
import createImage from './image';
import createLogs from './logs';
import createButtons from './buttons';
import createValue from './value';
import createAlive from './alive';
import createNavigationRoute from './navigation-route';
import createJson from './json';
import createPlot from './plot';
import createRobotBattery from './robot-battery';
import createText from './text';
import createRobotTeleop from './robot-teleop';
import createUrl from './url';
import createRest from './rest';
import createRestRequest from './rest-request';
import createRobotState from './robot-state';
import createRobotImages from './robot-images'
import createRobotKPIS from './robot-kpis';
import createRobotLogs from './robot-logs';
import createRobotNavigation from './robot-navigation';

const components = {
    iframe: {component: createIframe},
    gauge: {component: createGauge},
    robotVelocities: {component: createRobotVelocities},
    image: {component: createImage},
    robotImages: {component: createRobotImages},
    logs: {component: createLogs},
    robotLogs: {component: createRobotLogs},
    buttons: {component: createButtons},
    value: {component: createValue},
    robotKPIS: {component: createRobotKPIS},
    robotState: {component: createRobotState},
    alive: {component: createAlive},
    navigationRoute: {component: createNavigationRoute},
    robotNavigation: {component: createRobotNavigation},
    json: {component: createJson},
    plot: {component: createPlot},
    robotBattery: {component: createRobotBattery},
    text: {component: createText},
    robotTeleop: {component: createRobotTeleop},
    url: {component: createUrl},
    rest: {component: createRest},
    restRequest: {component: createRestRequest}
};

export default components;
